
export default function Services() {
  const services = [
    {
      icon: 'ri-drop-fill',
      title: 'Installation et rénovation de salles de bains',
      description: 'Conception et réalisation complète de votre salle de bains, du sol au plafond, avec des finitions impeccables.',
      image: 'https://public.readdy.ai/ai/img_res/edc1dd60bbc3d3609456c53c699eaeea.jpg'
    },
    {
      icon: 'ri-fire-fill',
      title: 'Pose et remplacement de chauffe-eau',
      description: 'Installation de chauffe-eau électriques, thermodynamiques ou solaires. Remplacement et entretien de tous types d\'appareils.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20water%20heater%20installation%20in%20clean%20utility%20room%2C%20professional%20plumbing%20equipment%20with%20copper%20pipes%20and%20valves%2C%20bright%20white%20walls%2C%20organized%20technical%20space%2C%20high-quality%20residential%20installation%2C%20professional%20photography%20with%20natural%20lighting&width=600&height=400&seq=service002&orientation=landscape'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Recherche et réparation de fuites d\'eau',
      description: 'Détection précise des fuites avec équipement professionnel. Réparation rapide et durable pour éviter les dégâts.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20inspecting%20pipes%20with%20modern%20detection%20equipment%2C%20clean%20workspace%20with%20organized%20tools%2C%20bright%20lighting%20highlighting%20technical%20precision%2C%20residential%20plumbing%20system%20with%20chrome%20fixtures%2C%20professional%20service%20photography%20style&width=600&height=400&seq=service003&orientation=landscape'
    },
    {
      icon: 'ri-contrast-drop-fill',
      title: 'Entretien et débouchage de canalisations',
      description: 'Débouchage professionnel de canalisations bouchées, entretien préventif et curage pour éviter les engorgements.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20using%20modern%20drain%20cleaning%20equipment%20on%20residential%20pipes%2C%20clean%20workspace%20with%20professional%20tools%20and%20machinery%2C%20bright%20lighting%20showing%20technical%20expertise%2C%20chrome%20pipes%20and%20drainage%20system%2C%20high-quality%20service%20photography%20with%20organized%20professional%20environment&width=600&height=400&seq=service007&orientation=landscape'
    },
    {
      icon: 'ri-alarm-warning-fill',
      title: 'Dépannage urgent 7j/7',
      description: 'Service d\'urgence disponible tous les jours. Intervention rapide pour tous vos problèmes de plomberie.',
      image: 'https://readdy.ai/api/search-image?query=Emergency%20plumbing%20service%20van%20arriving%20at%20modern%20home%2C%20professional%20plumber%20with%20toolbox%20ready%20for%20urgent%20repair%2C%20bright%20daylight%20scene%2C%20clean%20residential%20neighborhood%2C%20reliable%20service%20concept%2C%20professional%20photography%20style&width=600&height=400&seq=service004&orientation=landscape'
    },
    {
      icon: 'ri-building-fill',
      title: 'Création et rénovation de réseaux sanitaires',
      description: 'Installation complète de réseaux d\'eau et d\'évacuation pour constructions neuves et rénovations.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20plumbing%20network%20installation%20with%20organized%20copper%20and%20PVC%20pipes%2C%20clean%20construction%20site%2C%20professional%20piping%20system%20layout%2C%20bright%20workspace%20with%20new%20fixtures%2C%20technical%20precision%20and%20quality%20craftsmanship%2C%20professional%20construction%20photography&width=600&height=400&seq=service005&orientation=landscape'
    },
    {
      icon: 'ri-settings-3-fill',
      title: 'Entretien des équipements de plomberie',
      description: 'Maintenance préventive et curative de tous vos équipements sanitaires pour garantir leur longévité.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20performing%20maintenance%20on%20modern%20bathroom%20fixtures%2C%20clean%20organized%20workspace%20with%20quality%20tools%2C%20chrome%20faucets%20and%20valves%20being%20serviced%2C%20bright%20natural%20lighting%2C%20professional%20service%20photography%20showing%20attention%20to%20detail&width=600&height=400&seq=service006&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 px-6 md:px-12 lg:px-24 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#F5A623]/10 px-4 py-2 rounded-full mb-4">
            <i className="ri-drop-fill text-[#F5A623]"></i>
            <span className="text-[#0F5E7E] font-semibold text-sm">NOS PRESTATIONS</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0F5E7E] mb-6">
            Des services complets pour tous vos besoins
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            De l'installation à la rénovation, en passant par le dépannage urgent, nous intervenons sur tous types de travaux de plomberie.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F5E7E]/80 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-14 h-14 bg-[#F5A623] rounded-lg flex items-center justify-center">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#0F5E7E] mb-3 group-hover:text-[#F5A623] transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
